import './CategorizationPage.scss'
import React, {useEffect} from "react";
import {CategorizationWelcome} from "./components/welcome/CategorizationWelcome";
import {Alert, Button, Dialog, Grid} from "@mui/material";
import {ChevronRight} from "@mui/icons-material";
import {useLocation, useNavigate, useSearchParams} from "react-router";
import {generateHomePath} from "../../routing/routing.utils";
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import {CategorizationReviewPage} from "./CategorizationReviewPage";
import {ConfirmSendForApproval} from "./components/modals/ConfirmSendForApproval";
import {CategorizationStatisticsDashboard} from "./components/statistics/CategorizationStatisticsDashboard";
import {DemoAiBusy} from "./components/demo-ai-busy/DemoAiBusy";
import {AiBusyComponent} from "./components/ai-busy/AiBusyComponent";
import {RunAiModal} from "./components/modals/RunAiModal";
import {RevisionSelectorDropdown} from "./components/RevisionSelectorDropdown";
import * as CategorizationReviewUrls from "./classes/CategorizationReviewUrls";
import {CategoryMenuProvider} from "./context/CategoryMenuController";
import {MainPageFacade} from "../../components/main/page/MainPageFacade.tsx";
import {CategorizationPageHeader} from "./CategorizationPageHeader.tsx";
import {CARD_CONFIG} from "../../components/dashboard/DashboardCardConfigs.tsx";
import {ReviewSnackbar} from "./components/snackbar/ReviewSnackbar.tsx";

export type CategorizationPageProps = {
    viewOnly?: boolean
}
export const CategorizationPage: React.FC<CategorizationPageProps> = observer(({viewOnly}) => {
    const {rootAppStore, authStore, bagStore, categorizationReviewStore, p} = useStores();

    if (viewOnly !== undefined) {
        categorizationReviewStore.ensureViewOnlyIsSet(viewOnly);
    }

    const approvalController = categorizationReviewStore.reviewPageController.reviewPageApprovalController;
    const pageStateController = categorizationReviewStore.reviewPageController.reviewPageStateController;
    const aiJobDelegate = categorizationReviewStore.aiJobDelegate;

    const bagId = bagStore.bagId;
    const location = useLocation();
    const navigate = useNavigate();
    const back = generateHomePath(location, {id: String(bagId)}, rootAppStore.app)

    const [searchParams, setSearchParams] = useSearchParams();
    const locationStateSearchIntent = (location.state as CategorizationReviewUrls.UrlState)?.searchIntent ?? null;
    useEffect(() => {
        let intent = locationStateSearchIntent;
        if (!intent) {
            intent = CategorizationReviewUrls.urlToIntent(searchParams);
        }
        if (intent) {
            categorizationReviewStore.reviewPageController.initializeFromIntent(intent);
        }
    }, [categorizationReviewStore.reviewPageController, searchParams, setSearchParams, locationStateSearchIntent]);

    useEffect(() => {
        categorizationReviewStore.statusDelegate.checkStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <CategoryMenuProvider>
            <Dialog
                open={approvalController.isSendForApprovalDialogOpen}
                onClose={() => approvalController.setSendForApprovalDialog(false)}
                aria-labelledby={"review-modal-title"}
                fullWidth
                maxWidth="lg"
            >
                {approvalController.isSendForApprovalDialogOpen && <ConfirmSendForApproval/>}
            </Dialog>
            <Dialog
                open={categorizationReviewStore.aiJobDelegate.isRunAiModalOpen}
                onClose={() => categorizationReviewStore.aiJobDelegate.closeRunAiModal()}
                maxWidth="lg"
            >
                {categorizationReviewStore.aiJobDelegate.isRunAiModalOpen && <RunAiModal/>}
            </Dialog>
            <ReviewSnackbar/>

            <MainPageFacade
                title={CARD_CONFIG['categorization-review'].title}
                className="categorization-page"
                actionBarEnd={<CategorizationPageHeader/>}
                // back={pageStateController.previousLabel ? {
                //     type: 'component',
                //     node: <Button
                //         color="primary"
                //         variant="outlined"
                //         startIcon={<ChevronLeft/>}
                //         onClick={() => pageStateController.onClickPrevious(navigate, back)}
                //         className="button-spacing">
                //         {pageStateController.previousLabel}
                //     </Button>
                // } : undefined}
            >

                {pageStateController.page === 'review-dashboard' && categorizationReviewStore.reviewPageController.reviewPageStatisticsController._reviewLevelStatistics.error &&
                    <Grid container justifyContent="center">
                        <Grid>
                            <Alert severity="warning">
                                The categorization review is not available
                                ({categorizationReviewStore.reviewPageController.reviewPageStatisticsController._reviewLevelStatistics.error})
                            </Alert>
                        </Grid>
                    </Grid>
                }

                <Grid container alignItems="center" className="header">

                    <Grid size={7}>
                        <RevisionSelectorDropdown/>
                    </Grid>

                    <Grid className="align-with-stepper" size={3}>
                        {}
                        {pageStateController.nextLabel &&
                            <Button
                                color="primary"
                                variant="outlined"
                                disabled={categorizationReviewStore.reviewPageController.isLoadingData}
                                className="button-spacing"
                                endIcon={<ChevronRight/>}
                                onClick={() => pageStateController.onClickNext()}
                            >
                                {pageStateController.nextLabel}
                            </Button>
                        }
                    </Grid>
                </Grid>

                {pageStateController.page === 'welcome' &&
                    <CategorizationWelcome/>
                }
                {pageStateController.page === 'demo-ai-run' &&
                    <DemoAiBusy/>
                }
                {pageStateController.page === 'ai-busy' &&
                    <AiBusyComponent/>
                }
                {pageStateController.page === 'review-dashboard' &&
                    <CategorizationStatisticsDashboard/>
                }
                {(pageStateController.page === 'review') &&
                    <CategorizationReviewPage/>
                }

            </MainPageFacade>

        </CategoryMenuProvider>
    );
});
